import React from 'react';

export default () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} fill="none">
            <path
                stroke="#AD8518"
                strokeLinejoin="round"
                strokeWidth={1.954}
                d="M32.016 63.031c17.129 0 31.015-13.886 31.015-31.015C63.031 14.886 49.145 1 32.016 1 14.886 1 1 14.886 1 32.016 1 49.145 14.886 63.03 32.016 63.03Z"
            />
            <path
                stroke="#AD8518"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.954}
                d="M32.25 46.051v11.723m0-51.509v11.107M17.118 32.068H7.21m50.082 0H45.835M22.142 42.282l-8.108 8.107m36.424-36.423-7.941 7.94m-20.749-.139-7.266-7.266m35.42 35.421-8.108-8.1m8.923-17.462 2.218-.92m-14.06-8.041 2.858-6.894m-18.117 4.631-.912-2.21"
            />
            <path
                stroke="#AD8518"
                strokeLinejoin="round"
                strokeWidth={1.954}
                d="M31.827 45.811c7.582 0 13.728-6.146 13.728-13.727 0-7.582-6.146-13.728-13.728-13.728-7.581 0-13.727 6.146-13.727 13.727 0 7.582 6.146 13.728 13.727 13.728Z"
            />
            <path
                stroke="#AD8518"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.954}
                d="m18.584 26.887-5.335-2.497m.801 15.168-2.218.913m13.947 5.272-3.244 7.822m16.095-4.239.913 2.218M45.45 38.05l3.41 1.41"
            />
        </svg>
    );
};
